<template>
	<row-object-page name="task_edit" :oref="oref" v-model="task" :force-info="true" :parent-errors="extraErrors" ref="rowObject"></row-object-page>
</template>

<script setup lang="ts">
import {ref, computed, provide, reactive} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {PRINTS_GROUP_ID, SideMenu, TOOLS_GROUP_ID} from "@t/ui/Menu.ts";
import type {Task} from "@t/task/Task.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {ErrorMap} from "@fd/PartInjectKeys.ts";
import {hasAccess, isSecured} from "@t/security/ObjectAccess.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";

const ns = useNavigationStore();
const env = injectEnv();
const bus = connectEventBus("TaskPage")

const task = ref<Task>(null);
const rowObject = ref<InstanceType<typeof RowObjectPage> | null>(null);
const extraErrors = reactive<ErrorMap>([]);
const route = useVirtualRoute();
const oref = objectRef(route, SrcType.TASK);

ns.listenForStackerUpdates(bus, oref, () => env.msg('title.createTask'),
	"/editTask.do", () => task.value.subject, () => task.value.id);

ns.defineMenu((mb) => {
	if (task.value?.id) {
		mb.pageNamed("task_edit");
		mb.inGroup(TOOLS_GROUP_ID, (gb) => {
			gb.navItem("seeThis", "see.do?id="+task.value?.id+"&type="+SrcType.TASK, "menu.seeThis", "eye-eyebrow");
			if (hasAccess(task.value, "delete")) {
				gb.confirmDelete(gb.navItem("deleteTask", "deleteTask.do?id="+task.value.id, "menu.deleteTask", "trash"), "menu.deleteTask.confirm");
			}
		});
		mb.inGroup(PRINTS_GROUP_ID, (gb) => {
			gb.navItem("outputParams", "outputParams.do?descriptor=2&pk=" + task.value.id + "&section="+ns.activeSection, "title.printTask", "printer");
		});
	}
});
</script>

<style>

</style>
